import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class GridRouterLinkComponent extends Vue {
    @Prop({ default: '' }) public text: string;
    @Prop({ default: '' }) public url: string;
    @Prop({ default: () => null }) public entity: any;
}
